import React, { forwardRef, useImperativeHandle, useState } from 'react';
import Cross from '../../../assets/cross.svg';


interface Props {
    header: string
    submitBtnText: string
    isPending?: boolean
    onSubmit: Function
}

export type PopupConfirmHandle = {
    togglePopup: () => void;
};

export const PopupConfirm = forwardRef<PopupConfirmHandle, Props>(({
    header,
    submitBtnText,
    isPending,
    onSubmit
}: Props, ref) => {
    const [popupVisible, setPopupVisible] = useState<boolean>(false);

    useImperativeHandle(ref, () => ({
        togglePopup() {
            togglePopupVisibility();
        }
    }));

    const togglePopupVisibility = () => {
        setPopupVisible(!popupVisible)
    }

    return (
        <>
            {popupVisible ?
                <div className='fixed z-10 top-0 left-0 bg-melon-black/50 h-screen w-screen flex overflow-hidden justify-center'>
                    <div className='flex flex-col justify-center'>
                        <div className='flex flex-col bg-melon-white p-7 max-w-80 h-fit gap-4 rounded-lg'>
                            <div className='flex'>
                                <div className='text-2xl'>
                                    {header}
                                </div>

                                <button
                                    className='bg-melon-light p-1 rounded w-6 h-fit'
                                    onClick={() => {
                                        togglePopupVisibility();
                                    }}
                                >
                                    <img src={Cross} width={16} height={16} alt='Close' />
                                </button>
                            </div>

                            <button
                                className={'p-3 rounded-lg grow flex ' + (isPending ? 'bg-melon-light cursor-progress' : 'bg-melon-yellow')}
                                onClick={() => {
                                    onSubmit();
                                    togglePopupVisibility();
                                }}
                            >
                                <div className='mx-auto'>
                                    {submitBtnText}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                :
                <></>
            }
        </>
    );
});
